<template>
  <header class="app-header">
    <div class="bar">

      <button
        class="burger"
        :aria-label="menuOpen ? 'Close menu' : 'Open menu'"
        :aria-expanded="menuOpen"
        @click="$emit('toggle-menu')"
      >
        <span></span><span></span><span></span>
      </button>

      <router-link class="brand" :to="{ name: 'Sites' }">
        <img class="logo" src="@/assets/Epoka.png" alt="Epoka">
        <span class="divider"></span>
        <span class="product">Vero</span>
      </router-link>

      <div v-if="authState.account" class="account">
        <span class="who">{{ authState.account.name }}</span>
        <button class="sign-out" @click="handleLogout">Sign out</button>
      </div>

    </div>

  </header>
</template>

<script setup>
import { authState, logout } from '@/auth/authService'

// The menu is a sibling in the app shell rather than a child of the header, so
// the page layout can shift when it opens. The header only asks for it to be
// toggled.
defineProps({ menuOpen: Boolean })
defineEmits(['toggle-menu'])

async function handleLogout() {
  await logout()
}
</script>

<style scoped>
.app-header {
  position: sticky;
  top: 0;
  /* Above the sidebar, which starts below it. */
  z-index: 110;
  background: #fff;
  border-bottom: 1px solid #c3d3dc;
}

/* Full width, not a centred 1120px column.
   Centring it made sense when the page was the whole window; with a sidebar it
   left the logo floating in the middle while everything below started at the
   left edge. */
.bar {
  padding: 0 24px;
  height: 60px;
  display: flex;
  align-items: center;
  gap: 18px;
}

.burger {
  flex: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  width: 30px;
  height: 30px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
}

.burger span {
  display: block;
  height: 2px;
  background: #003c6c;
  border-radius: 1px;
}

/* ---------- Brand ---------- */

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  flex: none;
  /* Was the nav's job before it was removed: everything else goes right. */
  margin-right: auto;
}

/* The logo was 100px tall and pushed every page below the fold. At 26px it
   identifies the product without competing with the page content. */
.logo {
  height: 26px;
  width: auto;
  display: block;
}

.divider {
  width: 1px;
  height: 20px;
  background: #c3d3dc;
}

.product {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: #003c6c;
}

/* ---------- Account ---------- */

.account {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: none;
}

.who {
  font-size: 13.5px;
  font-weight: 500;
  color: #003c6c;
}

.sign-out {
  font-family: inherit;
  font-size: 12.5px;
  color: #4a6d8a;
  background: none;
  border: 1px solid #c3d3dc;
  padding: 5px 12px;
  cursor: pointer;
}

.sign-out:hover {
  border-color: #003c6c;
  color: #003c6c;
}

@media (max-width: 720px) {
  .bar {
    padding: 0 18px;
    gap: 18px;
  }

  .who {
    display: none;
  }

  .product {
    font-size: 15px;
  }
}
</style>
